class knowledgeController {
    constructor($sce) {
        "ngInject";
        this.$sce=$sce;
        this.name = 'knowledge';
        this.cata = [
            {
                title: '原本知识点',
                list: [
                    {
                        question: '什么是原本DNA标签？',
                        answer: '原本通过区块链及密码学技术，为每一篇认证作品生成全网唯一的数字指纹——DNA。DNA的表现形式是作品底部携带着的DNA标签。标签中包含了作品内容、作者信息、可信时间戳以及授权协议，它的功能有：<br>' +
                        '1.可以声明原创所有权，通过DNA码追溯原创作品，确保作品与作者的唯一对应关系<br>' +
                        '2.具备切实的版权效力，是发生侵权纠纷的重要证据<br>' +
                        '3.转载者可以通过标签上的DNA码快速获取作品授权，实现版权自助交易<br>' +
                        '4.提升原本链的公信力'
                    },
                    {
                        question: 'DNA标签如何具备原创认证效力？',
                        answer: '原创认证由「所有权证明」和「存在证明」两部分组成。<br>' +
                        '「所有权证明」使用数字签名技术来证明您是此原创作品的原始作者。数字签名通过验证一组公钥和密钥的匹配来证明所有权。公钥已写入「原本DNA」，随着原创作品一起发布。密钥已通过邮件发送到您的邮箱。为了安全，系统中不保存密钥，请您妥善保存此密钥，在任何情况下都不要泄露给其他人。<br>' +
                        '「存在证明」用于证明原创作品的发布时间，使用了区块链技术以及来自国家数字证书中心的可信时间戳服务，认证信息也已经写入「原本DNA」中。<br>' +
                        '原本认证不依赖于「原本」的权威性，可以脱离「原本」的系统，由任意第三方来验证。'
                    },
                    {
                        question: '什么是可信时间戳？',
                        answer: '可信时间戳是由权威可信时间戳服务中心签发的一个能证明数据电文(电子文件）在一个时间点是已经存在的、完整的、可验证的，具备法律效力的电子凭证，可信时间戳主要用于电子文件防篡改和事后抵赖，确定电子文件产生的准确时间。'
                    },
                    {
                        question: '什么是原本链？',
                        answer: '原本链是基于区块链技术的一条联盟链。任何合作伙伴可以成为原本链的节点，为原本链带来更强的公信力。它是一套不可篡改的底层协议，为认证作品的DNA码带来公信力与版权效力。<br>' +
                        '由于原本链的分布式架构，原本认证不依赖于「原本」的权威性，可以脱离「原本」的系统，由任意第三方来验证。'
                    },
                    {
                        question: '为什么建议先认证版权，再发表作品？',
                        answer: '原本的核心理念在于通过区块链技术降低作品的授权成本，增加作品的传播力度，以此为作者带来全新的创作价值。当作品先认证再发表到媒体平台，已发布作品的底部才会携带上唯一数字身份DNA标签，广大转载者可以通过DNA标签快速获取作品授权，实现版权交易。'
                    }

                ]
            }
        ]
    }
    showDetail(event){
        let $answer=$(event.currentTarget).next();
        if($answer.hasClass('active')){
            $answer.removeClass('active');
        }else{
            $answer.addClass('active');
        }
    }
}

export default knowledgeController;



// WEBPACK FOOTER //
// ./src/app/components/page/help/knowledge/knowledge.controller.js